import React, { useState } from 'react';
import { useStoreActions } from 'easy-peasy';
import { Box, Typography, List } from '@material-ui/core';
import LinkifyComponent from '../common/linkifyComponent';
import PollOptions from './pollOptions';
import { ReactComponent as SorryIcon } from '../../img/sorry.svg';
import { useSnackBar } from '../../hooks/snackBarHooks';

const PollContent = ({ post, isPostDetail }) => {
  const [disablePollOption, setDisablePollOption] = useState({
    index: null,
    value: false,
  });
  const setToastMessage = useSnackBar('');
  const { setErrorDialogBoxOpen, setErrorDialogContent } = useStoreActions(
    (actions) => actions.errorHandler
  );
  const submitPoll = useStoreActions((actions) => actions.posts.submitPoll);
  let options = post.pollOptions;
  const pollId = post.entityId;
  const pollType = post.pollType;
  const showResult =
    (post.isResponseOnPoll && post.showResult) || post.isExpired;

  async function handleSubmitPoll(e, pollId, pollOptionId, index) {
    if (showResult) return;
    setDisablePollOption({
      index: index,
      value: true,
    });
    e.stopPropagation();
    await submitPoll({
      pollId,
      pollOptionId,
      setToastMessage,
    });
    setErrorDialogBoxOpen(true);
    setErrorDialogContent({
      btnPrimaryText: 'Not Now',
      btnSecondaryText: 'Verify',
      dialogIcon: <SorryIcon />,
      dialogTitle: 'Sorry!',
    });
    setDisablePollOption({ index: index, value: false });
  }

  return (
    <React.Fragment>
      <Box
        className="cursorPointer"
        mt={-3}
        whiteSpace="pre-line"
        pb={2}
        px={4}
      >
        <Typography variant="subtitle1" color="textPrimary">
          <LinkifyComponent //Urlify the links.
            shouldTruncate={!isPostDetail}
            textLimit={300}
            content={post.description}
          />
        </Typography>
      </Box>
      <Box pb={2} px={4} className="cursorPointer">
        <List component="nav">
          <PollOptions
            pollId={pollId}
            handleSubmitPoll={handleSubmitPoll}
            disablePollOption={disablePollOption}
            showResult={showResult}
            pollType={pollType}
            options={options}
          />
        </List>
        <Box className="clearfix"></Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="caption" color="textSecondary">
            {post.endDate}
          </Typography>

          {post.totalVotes >= 1 && (
            <Typography variant="caption" color="textSecondary">
              {post.totalVotes} {post.totalVotes < 2 ? 'vote' : 'votes'}
            </Typography>
          )}
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default PollContent;
